export const validateName = (value: string) => {
  return /(^[a-zA-Z0-9_\-,.()])([a-zA-Z0-9_\- ,'.()$%/&!#@]{0,98})([a-zA-Z0-9_\-,.()$%/&!#@])$/.test(value);
};
export const validateDescription = (value: string) => {
  return value.length <= 10000;
};
